import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

const styles = stylex.create({
    footer: {
        width: '100%',
        padding: '1.5rem 1rem',
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.4)',
        fontSize: '0.8rem',
        fontFamily: "'Montserrat', sans-serif",
        marginTop: '3rem',
        position: 'relative',
        zIndex: 1,
    },
});

export default function Footer() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer {...stylex.props(styles.footer)}>
            <div>
                {t('site.copyright', { year: currentYear })}
            </div>
        </footer>
    );
} 